import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, [
  /*#__PURE__*/_createTextVNode("Sla de keuring als concept op om later nog wijzigingen te maken."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Of onderteken de keuring om de keuring definitief te kunnen voltooien.")
], -1)
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "no-mb",
  style: {"font-weight":"bold"}
}
const _hoisted_4 = { class: "no-mb" }
const _hoisted_5 = {
  class: "no-mb",
  style: {"font-weight":"bold"}
}
const _hoisted_6 = { class: "no-mb" }

import { surveyStore } from '@/stores/survey'
import { authStore } from '@/stores/auth'
import SignatureField from '@/components/SignatureField.vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveySignCard',
  setup(__props) {

const signature = ref<File|null>(null)
const screenWidth = computed(() => window.innerWidth)

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Ondertekenen",
    bordered: false
  }, {
    default: _withCtx(() => [
      (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
        ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
        ? (_openBlock(), _createBlock(_component_a_divider, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                ? (_openBlock(), _createBlock(SignatureField, {
                    key: 0,
                    "return-type": "file",
                    width: _unref(screenWidth) >= 400 ? '300px' : '100%',
                    height: "200px",
                    signatureName: 'Keuring_' + _unref(surveyStore)().survey.id + '_Handtekening_Gebruiker_' + _unref(surveyStore)().survey.scheduled_user_id,
                    onSignatureSave: _cache[0] || (_cache[0] = ($event: any) => (signature.value = $event)),
                    onSignatureCleared: _cache[1] || (_cache[1] = ($event: any) => (signature.value = null))
                  }, null, 8, ["width", "signatureName"]))
                : (!_unref(surveyStore)().surveyClosed && !_unref(surveyStore)().isSurveyOwner)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Deze keuring is nog niet ondertekend.")
                    ], 64))
                  : (_unref(surveyStore)().surveyClosed && _unref(surveyStore)().survey.signature)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: _unref(surveyStore)().survey.signature
                      }, null, 8, _hoisted_2))
                    : (_unref(surveyStore)().surveyClosed && !_unref(surveyStore)().survey.signature)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode("Handtekening niet gevonden.")
                        ], 64))
                      : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(surveyStore)().surveyClosed && !_unref(surveyStore)().isSurveyOwner)
        ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(surveyStore)().survey.completed_by_user?.full_name || '-') + _toDisplayString(_unref(surveyStore)().survey.completed_by_user.company ? ' - ' + _unref(surveyStore)().survey.completed_by_user.company.name : ''), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(new Date(_unref(surveyStore)().survey.completed_at).toLocaleDateString('nl-NL')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_unref(surveyStore)().isSurveyOwner)
          ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(authStore)().user.full_name) + _toDisplayString(_unref(authStore)().user.company ? ' - ' + _unref(authStore)().user.company.name : ''), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(!_unref(surveyStore)().surveyClosed ? new Date().toLocaleDateString('nl-NL') : new Date(_unref(surveyStore)().survey.completed_at).toLocaleDateString('nl-NL')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
        ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    loading: _unref(surveyStore)().loading.saving,
                    disabled: !signature.value || _unref(surveyStore)().loading.saving,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(surveyStore)().completeSurvey(signature.value)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Definitief opslaan")
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})